import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Line from '../Misc/Line.js';
import LineTA from './LineTA.js';

class ThinkAloud extends Component {

  componentWillMount() {
    var {title, lines} = this.props.text;
    this.lines = lines.slice();
    this.lines.unshift(title);
  }

  componentDidUpdate(nextProps){
    //calls a line query on lineOrder update
    if(nextProps.thinkaloud.lineOrder !== this.props.thinkaloud.lineOrder){
      if(this.props.thinkaloud.running)
        this.props.queryLines(this.props.data.linesTA);
    }
  }

  componentWillUnmount(){
    this.props.endThinkaloud();
  }

  renderLines() {
    //compiles lines and handles state changes
    const {activeLine, lineOrder} = this.props.thinkaloud;
    const {linesTA, wordDelay, commaDelay} = this.props.data;
    let breakCount = 0;
    const payload = this.lines.map(function(line, key){
      //Handles line breaks in data e.g. ''
      if(line === ''){
        breakCount++;
        return <li key={'break_' + breakCount}>&nbsp;</li>;
      }
      const lineNum = key - breakCount;
      const className = key === 0 ? "title": "line";
      const words = line.split(' ');
      const active = activeLine === lineNum ? true : false;
      if(active)
        return (
          <LineTA
            className = {className}
            key = {'line_' + lineNum}
            dataTA = {{tooltips: linesTA[lineNum].tooltips, lineOrder}}
            commaDelay = {commaDelay}
            words={words}
            wordDelay = {wordDelay}
            nextLine = {this.nextLine.bind(this)}
          />
        );
      return (
        <Line
          className = {className}
          key = {'line_' + lineNum}
        >{line}</Line>
      )
    }.bind(this));
    return payload;
  }

  nextLine(){
    const {lineDelay} = this.props.data;
    setTimeout(this.props.nextLine.bind(this), lineDelay);
  }

  render() {
    return (
      <div id="ThinkAloud">
        <ul className="poem">
          {this.renderLines()}
        </ul>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    text: state.course.text,
    thinkaloud: state.thinkaloud
  };
}

export default connect(mapStateToProps, actions)(ThinkAloud);



// WEBPACK FOOTER //
// ./src/components/ThinkAloud/ThinkAloud.js